import { Component, inject } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { ReceiptRow } from '@app/pages/account/receipt/receipt.component';

@Component({
  selector: 'app-view-receipt-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    RouterLink,
    CurrencyPipe,
    DatePipe
  ],
  templateUrl: './view-receipt-dialog.component.html',
  styleUrl: './view-receipt-dialog.component.scss'
})
export class ViewReceiptDialogComponent {
  dialogRef = inject(MatDialogRef<ViewReceiptDialogComponent>);
  data: ReceiptRow | null = inject(MAT_DIALOG_DATA, { optional: true });

  close() {
    this.dialogRef.close();
  }

  formatDuration(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const secs = 0;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  getStatusClass(status: string): string {
    const statusMap: Record<string, string> = {
      'Completed': 'status-completed',
      'Pending': 'status-pending',
      'Failed': 'status-failed',
      'Refunded': 'status-refunded'
    };
    return statusMap[status] || 'status-default';
  }
}
